
<template>
    <div>
        
        <div class="deal-details-container" v-if="deal">
            <div class="deal-image-container">
                <a :href="(settings.isShabbat ? '#' : deal.DealURL)" target="_blank" class="button-link" id="deal-url" @click="goToDeal(deal, $event)">
                    <div class="deal-image-soldout" v-if="deal.isSoldOut"><img src="/Assets/img/soldout.png" /></div>
                    <img id="img-url" :src="deal.ImgUrl" :class="{'up-side-down': settings.purimMode}" />
                </a>
            </div>
            <div class="deal-info-container">
                <div class="deal-title"><h1 id="deal-title">{{deal.Title}}</h1></div>
                <div class="deal-last-update">Last Updated {{deal.UpdateDate | formatDate}}</div>
                <div class="deal-desc" id="deal-desc" v-if="deal && deal.Description">
                    {{deal.Description}}
                </div>
                <div class="crossed-price pad-top" :class="{'hide-price': deal.DealPrice == '-1'}"><span v-if="deal.RetailPrice" id="retail-price">{{deal.RetailPrice | toCurrency(2)}}</span></div>
                <div class="deal-price" id="sale-price" :class="{'hide-price': deal.DealPrice == '-1'}">{{deal.DealPrice | toCurrency(2)}}</div>
                <div class="deal-promo-code" v-if="deal.PromoCode">
                    <div class="deal-promo-code-title">Promo Code</div>
                    <div class="share-link-container">
                        <input id="promoCode" v-model="deal.PromoCode" class="promo-code-input" readonly />
                        <a v-show="!copied" class="promo-copy-code" @click="copyToClipboard()">COPY</a>
                        <a v-show="copied" class="promo-copy-code copied">COPIED</a>
                    </div>

                </div>
                <div class="deal-button-container">
                    <a :href="(settings.isShabbat ? '#' : deal.DealURL)" target="_blank" class="button-link" id="deal-url" @click="goToDeal(deal, $event)">
                        <button id="button-deal" class="button">Get Deal</button>
                    </a>
                    <input type="hidden" id="product-id" :value="deal.ProductID" />
                    <a :href="linkToJoinWhatsAppGroup" target="_blank" @click="joinWhatsapp(linkToJoinWhatsAppGroup)">
                        <button class="button-cta"><span class="play-icon"><img src="/assets/img/logo-whatsapp.png" /></span>Join {{settings.siteNameCaps}}</button>
                    </a>
                </div>

                <div class="deal-amazon-img-container">
                    <img v-if="deal.DealProvider == 'Etsy'" class="amzn-img" src="/assets/img/logo-etsy.png">
                    <img v-else-if="deal.DealProvider == 'Walmart'" class="walmart-img" src="/assets/img/walmart_logo.png">
                    <img v-else-if="deal.DealProvider == 'Chewy'" class="walmart-img" src="/assets/img/chewy.png">
                    <img v-else-if="deal.DealProvider == 'PatPat'" class="patpat-img" src="/assets/img/patpat_logo.png">
                    <img v-else-if="deal.DealProvider == 'Kohls'" class="logo-img" alt="Kohls logo" src="/assets/img/logos/groupon.png">
                    <img v-else-if="deal.DealProvider == 'Groupon'" class="logo-img" alt="Groupon logo" src="/assets/img/logos/groupon.png">
                    <img v-else-if="deal.DealProvider == 'OldNavy'" class="logo-img" alt="Old Navy logo" src="/assets/img/logos/oldnavy.png">
                    <img v-else-if="deal.DealProvider == 'Zappos'" class="logo-img" alt="Zappos logo" src="/assets/img/logos/zappos.png">
                    <img v-else-if="deal.DealProvider == 'Petco'" class="logo-img" alt="Petco logo" src="/assets/img/logos/petco.png">
                    <img v-else-if="deal.DealProvider == 'PetSmart'" class="logo-img" alt="PetSmart logo" src="/assets/img/logos/petsmart.png">
                    <img v-else-if="deal.DealProvider == 'Zulily'" class="logo-img" alt="Zulily logo" src="/assets/img/logos/zulily.png">

                    <img v-else class="amzn-img" src="/assets/img/amazon-logo-640.png">
                </div>
                <div class="expiration-message" v-if="deal.expirationMessage">
                    {{deal.expirationMessage}}
                </div>               
                <br>
                <div id="deal-expired">
                    Disclosure: {{settings.siteNameCaps}} is a participant in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for us to earn advertising fees by advertising and linking to Amazon.com. As An Amazon Associate we earn from qualifying purchases. Product prices and availability are accurate as of the date/time indicated and are subject to change without notice including promo codes.
                </div>

            </div>
        </div>
    </div>
</template>



<script>
    import api from '@/api'
    import settings from '@/settings'
    import util from '@/helpers/util'
    import ga from '@/helpers/ga'
    import clicky from '@/helpers/clicky'
    import moment from 'moment'
    //import VueGoodshare from "vue-goodshare";
    //import VueGoodshareFacebook from "vue-goodshare/src/providers/Facebook.vue";
    

    export default {
        props: ['dealId'],
        data() {
            return {
                isLoading: false,
                currentUrl: window.location.href,
                deal: null,
                linkToJoinWhatsAppGroup: settings.socialLinks.whatsapp,
                dealUrl: null,
                isParticipant: null,
                descLength: 80,
                copied: false
            };
        },
        created() {
            this.init();
        },
        computed: {
            settings: function () { return settings; }
        },
        methods: {
            init() {
                this.isLoading = true;
                api.getDeal(this.dealId).then(response => {

                    let tempDeal = response.data;

                    //check if an affiliate sent the traffic to us, if so, update the deal url
                    let cookie_lastref = this.$cookie.get("MMD_LastRef");
                    if (settings.siteName == 'fivetowncentral' || (cookie_lastref && cookie_lastref.toLowerCase() == '5townscentral')) {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'tag', '5townscentral-20');
                    }
                    else if (settings.siteName == '5tcdeals') {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'tag', '5townscentral-20');
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'sharedid', '5tcdeals');
                    }
                    else if (settings.siteName == 'momazon' || (cookie_lastref && cookie_lastref.toLowerCase() == 'adir')) {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'tag', 'adirdeals-20');
                    }
                    else if (settings.siteName == 'alyssagoldwater' || (cookie_lastref && cookie_lastref.toLowerCase() == 'alyssagoldwater')) {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'tag', 'agoldwater-20');
                    }
                    else if (cookie_lastref && cookie_lastref.toLowerCase() == 'mmdfriedman') {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'tag', 'mmdfriedman-20');
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'sharedid', 'moshe');
                    }
                    else if (cookie_lastref && cookie_lastref.toLowerCase() == 'klugman') {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'tag', '18ventures-20');
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'sharedid', 'klugman');
                    }
                    else if (cookie_lastref && cookie_lastref.toLowerCase() == 'dovidklugman') {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'tag', 'mmdbraum-20');
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'sharedid', 'dovidklugman');
                    }
                    else if (cookie_lastref && cookie_lastref.toLowerCase() == 'braum') {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'tag', 'mmdbraum-20');
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'sharedid', 'braum');
                    }
                    else if (cookie_lastref && cookie_lastref.toLowerCase() == 'tempelberg') {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'tag', 'tempelberg-20');
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'sharedid', 'tempelberg');
                    }
                    else if (settings.siteName == 'mommydeals' && tempDeal.DealProvider == 'Amazon') {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'tag', 'mommydeals0a-20');
                    }
                    else if (settings.siteName == 'mommydeals' && tempDeal.DealProvider == 'Walmart') {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'sharedid', 'mommydeals');
                    }
                    else if (settings.siteName == 'petpetdeals' && tempDeal.DealProvider == 'Amazon') {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'tag', 'petpetdeals-20');
                    }
                    else if (settings.siteName == 'petpetdeals' && tempDeal.DealProvider == 'Walmart') {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'sharedid', 'petpetdeals');
                    }
                    else if (settings.siteName == 'chaideals' && tempDeal.DealProvider == 'Amazon') {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'tag', 'chaideals-20');
                    }
                    else if (settings.siteName == 'chaideals' && tempDeal.DealProvider == 'Walmart') {
                        tempDeal.DealURL = util.replaceOrAddUrlParam(tempDeal.DealURL, 'sharedid', 'chaideals');
                    }

                    if (tempDeal.isExpired) {
                        tempDeal.expirationMessage = 'Note: This deal might be expired since was it was posted ' + moment(tempDeal.UpdateDate).fromNow();
                    }
                    else {
                        tempDeal.expirationMessage = null;
                    }

                    this.deal = tempDeal;
                    this.isLoading = false;
                    document.title = this.deal.Title + ' | ' + settings.siteNameCaps;

                    //isParticipant
                    this.loadGoogleAds();

                });
            },
            shortDesc: function () {
                if (this.deal && this.deal.Description && this.deal.Description.length > this.descLength) {
                    return this.deal.Description.substring(0, this.descLength);
                }
                else {
                    return this.deal.Description;
                }
            },
            copyToClipboard() {
                var copyText = document.getElementById("promoCode");
                copyText.select();
                document.execCommand("copy");
                this.copied = true;
                setTimeout(() => {
                    this.copied = false;
                }, 2000);
            },
            longDesc: function () {
                this.descLength = this.deal.Description.length;
            },
            trackOutboundLink: function (url) {

                ga.event('click', { 'event_category': 'outbound', 'event_label': url, 'transport_type': 'beacon' });
                clicky.goal('DealClick2')

            },
            joinWhatsapp() {
                ga.event('click', { 'event_category': 'whatsapp', 'event_label': 'whatsapp', 'transport_type': 'beacon' });
                clicky.goal("JoinWhatsApp2")
            },
            goToDeal: function (deal, event) {
                if (settings.isShabbat) {

                    alert(`Thank you for your patience while ${settings.siteNameCaps} breaks for the Shabbos holiday.

Deal links will resume to work on ${settings.shabbatEnds}.`);
                    event.preventDefault();
                }
                else {
                    this.trackOutboundLink(deal.DealURL);
                }
            },
            showJoinWhatsapp: function () {
                this.showWhatsapp = true;
            },
            loadMetaTags: function () {

                var arrayOfTags = [];

                if (this.deal.Title) arrayOfTags.push({ name: 'og:title', content: settings.siteNameCaps + ' | ' + this.deal.Title });
                if (this.deal.Description) arrayOfTags.push({ name: 'og:description', content: this.deal.Description });
                if (this.deal.ImgUrl) arrayOfTags.push({ name: 'og:image', content: this.deal.ImgUrl });


                for (let index = 0; index < arrayOfTags.length; index++) {

                    let metaTag = document.createElement('meta');
                    metaTag.name = arrayOfTags[index].name;
                    metaTag.content = arrayOfTags[index].content;
                    document.getElementsByTagName('head')[0].appendChild(metaTag);
                }

            },
            loadGoogleAds() {

                //document.querySelectorAll('.adsbygoogle').forEach(function () {
                //    (window.adsbygoogle = window.adsbygoogle || []).push({});
                //});

            }
        }
    };
</script>